import React, { useEffect, useState, useRef } from 'react';
export default function AskUserLocation({
  ...props
}) {
  const [visible, setVisible] = useState(props.ask === true);
  const _ref_timeout = useRef();
  const _ref_success = useRef();
  const _ref_error = useRef();
  const _ref_ask = useRef();
  useEffect(function () {
    _ref_timeout.current = props.onTimeout;
    _ref_success.current = props.onSuccess;
    _ref_error.current = props.onError;
    setVisible(props.ask === true);
  }, [props.ask]);
  useEffect(function () {
    if (!visible) return () => {
      window.clearTimeout(_ref_ask.current);
    };
    _ref_ask.current = window.setTimeout(function () {
      _ref_ask.current = null;
      _ref_timeout.current?.();
    }, 10 * 1000);
    navigator.geolocation.getCurrentPosition(function (data) {
      window.clearTimeout(_ref_ask.current);
      _ref_ask.current = null;
      _ref_success.current?.(data);
    }, function (info) {
      window.clearTimeout(_ref_ask.current);
      _ref_ask.current = null;
      _ref_error.current?.(info);
    });
    return () => {
      window.clearTimeout(_ref_ask.current);
    };
  }, [visible]);
  return null;
}
